import React, {Component} from "react";
import {connect} from "react-redux";
import * as actions from "Actions";
import classnames from "classnames";
import {Link} from "react-router-dom";
import ForceSignoutModal from "../ForceSignoutModal";

class SimpleSignInForm extends Component {

  onSubmit(e) {
    e.preventDefault();
    const {email, password, loginUser} = this.props;
    loginUser({email, password});
  }

  render() {

    const {
      email,
      password,
      errors,
      fieldChanged,
      forcedSignOut,
      forcedNewTabSignOut,
      clearSignedInOnOtherDevice,
      loading
    } = this.props;

    return (
      <div className="contentWrapper">
        <header>
          <h1>Sign In</h1>
        </header>
        <div className="content thin">
          <form className="simpleForm" onSubmit={this.onSubmit.bind(this)}>
            <input
              name="email"
              type="text"
              placeholder="Email"
              className={classnames({error: errors.login})}
              value={email}
              onChange={e =>
                fieldChanged({field: "email", text: e.target.value})}
            />
            <input
              name="password"
              type="password"
              placeholder="Password"
              className={classnames({error: errors.login})}
              value={password}
              onChange={e =>
                fieldChanged({field: "password", text: e.target.value})
              }
            />
            <input className={loading ? "btn disabled" : "btn"} type="submit"
                   value={loading ? "Please wait..." : "Log in"}/>
            <Link id="sign_up" to="/signUp">
              Don't have an account? Sign Up
            </Link>
            <br/>
            <Link to="/forgotPassword">Forgot Password</Link>
          </form>
        </div>
        <ForceSignoutModal
          open={forcedSignOut || forcedNewTabSignOut}
          toggle={clearSignedInOnOtherDevice}
        />
      </div>
    );
  }
}


const mapStateToProps = state => {
  const {errors, loading} = state.auth;
  return {errors, loading};
};

export default connect(mapStateToProps, actions)(SimpleSignInForm);
